import "../css"
import Galleria from "galleria"

$(document).on("hidden.bs.modal", "#report_modal", function() {
  this.querySelector("#report-form").classList.remove("hidden")
  this.querySelector("#report-sent").classList.add("hidden")
})

addEventListener("keyup", ({ target }) => {
  if (target.matches("#report_content")) {
    const el = document.querySelector('#new_report input[type="submit"]')

    if (target.value == "") {
      el.classList.add("disabled")
    } else {
      el.classList.remove("disabled")
    }
  }
})

addEventListener("click", e => {
  if (e.target.closest(".photo-report-link") || e.target.closest(".video-report-link") || e.target.closest(".entry-report-link")) {
    e.preventDefault()

    let el = e.target
    if (!el.hasAttribute("data-report-id")) {
      el = Galleria.get(0).getData().original
    }

    document.querySelector("#report_reportable_id").value = el.dataset.reportId
    document.querySelector("#report_content").value = ""
    $("#report_modal").modal("show")
  }
})
